import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(() => {
  if (useAuth().loggedIn.value) {
    return
  }
  return navigateTo('/signup')
})
